module.exports = __webpack_public_path__ + "img/space3.3c4b9c0c.jpg";